import React from 'react'

const under = () => {
  return (
    <section className="cta" aria-label="call to action">
    <div className="container">


        <div className="section-titler">
            <h2 class="h2-title">
                Visa Consultation Services
            </h2>
            <p>Our team of visa experts specializes in EB1 and EB2 visa processing.
            We provide personalized consultation services to help you navigate 
             the complex visa requirements and increase your chances of success.</p>

        </div>
   
      
      <a href="/info" className='btn-primary btn emma'>Get In Touch</a>

    </div>
  </section>
  )
}

export default under